/// <amd-module name="Repos/Discussion/Editor/Widgets/DiscussionSummaryWidget" />
import { IDiffSummaryDiscussionWidget, LineInfoType } from "Repos/Discussion/Common/DiscussionContracts";
import { DiscussionBaseWidget, IDiscussionBaseWidgetProps, IDiscussionWidgetContentProps } from "./DiscussionBaseWidget";

export interface IDiscussionSummaryWidgetProps extends IDiscussionBaseWidgetProps<IDiscussionWidgetContentProps> {
    id: string;
    lookupDisplayLineNumber: (actualLineNumber: number, addToOriginalDiff: boolean) => number;
}

export class DiscussionSummaryWidget extends DiscussionBaseWidget<IDiscussionSummaryWidgetProps> implements IDiffSummaryDiscussionWidget {
    constructor(props: IDiscussionSummaryWidgetProps) {
        super(props);

        $DEBUG &&
            props.lineInfo &&
            props.lineInfo.type !== LineInfoType.Display &&
            console.warn("Detected a Discussion Summary Widget with a non-Display LineInfo; this is being constructed incorrectly");
    }

    public belongsToLine(lineNumber: number, addToOriginalDiff: boolean, infoType: LineInfoType) {
        if (infoType !== LineInfoType.Display) {
            lineNumber = this.props.lookupDisplayLineNumber(lineNumber, addToOriginalDiff);
        }

        return super.belongsToLine(lineNumber, addToOriginalDiff, LineInfoType.Display);
    }

    public getId() {
        return this.props.id;
    }
}
